import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosOtherRequestsTimeout } from '../helpers'

type MethodTypes = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

interface FetchParams extends AxiosRequestConfig {
  method?: MethodTypes
  path: string
  params?: object
  headers?: object
  data?: any
  body?: object
}

function fetch ({
  method = 'GET',
  path,
  params,
  headers,
  responseType,
  data,
  withCredentials,
}: FetchParams): Promise<AxiosResponse> {
  return new Promise(async (resolve, reject) => {
    const url = `${path}`
    try {
      axios({
        headers: {
          //Authorization: token && `Bearer ${token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          'Accept-Language': 'en',
          timeout: axiosOtherRequestsTimeout,
          ...headers,
        },
        url,
        method,
        params,
        responseType,
        data,
        withCredentials,
      })
        .then(async (response) => {
          if (response.data?.success === false) {
            reject({ response })
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } catch (error) {
      reject(error)
    }
  })
}

export default fetch
